import React from "react";
import PropTypes from "prop-types";
import BaseIntro from "./BaseIntro";
import _strf from "shared/util/_strf";
import _str from "shared/util/_str";
import Essay from "../shared/Essay";
import Compatibilities from "apps/messenger/components/Connections/shared/Compatibilities";

import { LikedVia } from "apps/messenger/components/Connections/constants";
import "apps/messenger/components/Connections/Prematch/Intro.scss";

function getHeaderCopy(likedVia, displayname) {
	const header = _strf("You liked $name!", { name: displayname });

	switch (likedVia) {
		case LikedVia.PHOTO: {
			return {
				header,
				subtitle: _str("Comment on their photo"),
			};
		}
		case LikedVia.ESSAY: {
			return {
				header,
				subtitle: _str("Comment on what they wrote"),
			};
		}
		default: {
			return {
				header,
				subtitle: _str("Introduce yourself"),
			};
		}
	}
}

function Intro({
	onClose,
	targetUser,
	onMessageEdit,
	sendMessage,
	draft,
	likedEssay,
	likedPhoto,
	likedVia,
	error,
}) {
	const {
		connection_compatibilities: connectionCompatibilities = [],
		userinfo: {
			displayname,
		} = {},
	} = targetUser;

	const { header, subtitle } = getHeaderCopy(likedVia, displayname);

	return (
		<div className="prematch-intro-edit">
			<BaseIntro
				header={header}
				subtitle={subtitle}
				onClose={onClose}
				targetUser={targetUser}
				onMessageEdit={onMessageEdit}
				sendMessage={sendMessage}
				draft={draft}
				error={error}
			>
				{!!connectionCompatibilities.length && likedVia === LikedVia.GLOBAL &&
					<Compatibilities>
						{ connectionCompatibilities }
					</Compatibilities>
				}

				{likedVia === LikedVia.PHOTO &&
					<div
						className="prematch-intro-edit-photo"
						style={{
							backgroundImage: `url(${likedPhoto})`,
						}}
					/>
				}

				{likedVia === LikedVia.ESSAY &&
					<div className="prematch-intro-edit-content">
						<Essay
							{...likedEssay}
						/>
					</div>
				}
			</BaseIntro>
		</div>
	);
}

Intro.propTypes = {
	onClose: PropTypes.func.isRequired,
	targetUser: PropTypes.shape({
		connection_compatibilities: PropTypes.array,
		userinfo: PropTypes.shape({
			displayname: PropTypes.string,
		}),
	}).isRequired,
	likedEssay: PropTypes.shape({
		title: PropTypes.string.isRequired,
		clean_content: PropTypes.string.isRequired,
	}),
	onMessageEdit: PropTypes.func.isRequired,
	sendMessage: PropTypes.func.isRequired,
	draft: PropTypes.string.isRequired,
	likedVia: PropTypes.oneOf(Object.values(LikedVia)),
	likedPhoto: PropTypes.string,
	error: PropTypes.string,
};

Intro.defaultProps = {
	likedEssay: {},
	likedPhoto: "",
	likedVia: LikedVia.GLOBAL,
	error: null,
};

export default Intro;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/Connections/Prematch/Intro.jsx